import React, { useState, useEffect, useCallback } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { cdnInstance } from "../../../../axiosInterceptor";
import { ImageLink } from "../../../../utils/constants";
import "./ProductImageUploader.css";
import { FiUploadCloud } from "react-icons/fi";

const MAX_IMAGES = 5;

const ProductImageUploader = ({ onUploadComplete, initialImages = [],uploaderId }) => {
  const [images, setImages] = useState([]);
  const [dragActive, setDragActive] = useState(false);
  useEffect(() => {
    if (!Array.isArray(initialImages)) return;

    setImages(
      initialImages.map((img) => ({
        id: uuidv4(),
        original: img.original,
        thumbImage: img.thumbImage,
        mediumImage: img.mediumImage,
      }))
    );
  }, [initialImages]);

  
  const uploadFiles = async (files) => {
    if (!files.length) return;

    if (images.length + files.length > MAX_IMAGES) {
      toast.error(`Max ${MAX_IMAGES} images allowed`);
      return;
    }

    try {
      const formData = new FormData();
      files.forEach((f) => formData.append("images", f));

      const res = await cdnInstance.post("/upload-product", formData);
      const uploaded = res?.data?.data;

      const formatted = uploaded.map((img) => ({
        id: uuidv4(),
        original: img.original,
        thumbImage: img.thumbImage,
        mediumImage: img.mediumImage,
      }));

      const updated = [...images, ...formatted];
      setImages((prev) => {
  const updated = [...prev, ...formatted];
  onUploadComplete?.(updated);
  return updated;
});
      onUploadComplete?.(updated);
    } catch {
      toast.error("Upload failed");
    } 
  };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    uploadFiles(Array.from(e.dataTransfer.files));
  };

  const handleDragEnd = useCallback(
    (result) => {
      if (!result.destination) return;

      const reordered = Array.from(images);
      const [moved] = reordered.splice(result.source.index, 1);
      reordered.splice(result.destination.index, 0, moved);

      setImages(reordered);
      onUploadComplete?.(reordered);
    },
    [images, onUploadComplete]
  );
  const handleDelete = async (index) => {
    const img = images[index];
    try {
      await cdnInstance.delete("/delete-product", { data: img });

      const updated = images.filter((_, i) => i !== index);
      // setImages(updated);
      setImages((prev) => {
  const updated = prev.filter((_, i) => i !== index);
  onUploadComplete?.(updated);
  return updated;
});
      onUploadComplete?.(updated);
    } catch {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="uploader-container">
      <input
        type="file"
       id={`hiddenInput-${uploaderId}`}
        hidden
        multiple
        accept="image/*"
        onChange={(e) => uploadFiles(Array.from(e.target.files))}
      />

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId={`dropzone-${uploaderId}`}  direction="horizontal">
          {(provided) => (
            <div
              className={`drop-zone ${dragActive ? "active" : ""}`}
              ref={provided.innerRef}
              {...provided.droppableProps}
            onClick={() =>
  document
    .getElementById(`hiddenInput-${uploaderId}`)
    .click()
}

              onDrop={handleDrop}
              onDragOver={(e) => {
                e.preventDefault();
                setDragActive(true);
              }}
              onDragLeave={() => setDragActive(false)}>
              {images.length === 0 && (
                <div className="empty-state">
                  <FiUploadCloud size={50} color="#4f46e5" className="mb-3" />
                  <p style={{ fontSize: "18px", fontWeight: "500", marginBottom: "5px" }}>
                                            Drag & Drop your Excel file here
                                        </p>
                                        <p style={{ fontSize: "14px", color: "#6b7280" }}>or click to browse</p>
                </div>
              )}

              {images.map((img, index) => (
                <Draggable
                  key={img.id}
                  draggableId={img.id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      className={`image-card ${
                        snapshot.isDragging ? "dragging" : ""
                      }`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <img src={ImageLink(img.original)} alt="product" />
                      <button
                      type="button"
                        className="delete-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  )}
                </Draggable>
              ))}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default ProductImageUploader;
